import SkeletonProvider from "@providers/SkeletonProvider";
import { darkTheme } from "@styles";
import { ThemeProvider } from "next-themes";
import { ComponentProps, ReactNode } from "react";

interface CustomThemeProviderProps extends ComponentProps<typeof ThemeProvider> {
  children: ReactNode | ReactNode[];
}

export default function CustomThemeProvider({ children, ...props }: CustomThemeProviderProps) {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      value={{
        light: "light",
        dark: darkTheme.className,
      }}
      {...props}
    >
      <SkeletonProvider>{children}</SkeletonProvider>
    </ThemeProvider>
  );
}
